import { useEffect } from "react"

export function useCustomEventListener<T = unknown>(
  event: string,
  callback: (event: CustomEvent<T>) => void
) {
  useEffect(() => {
    window.addEventListener(event, callback as EventListener)

    return () => {
      window.removeEventListener(event, callback as EventListener)
    }
  }, [event, callback])
}
